// extracted by mini-css-extract-plugin
export default {"order-feedback-card":"Feedback_order-feedback-card__3kRSn","payment-specific-feedback":"Feedback_payment-specific-feedback__whG3u"};